import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyModalModule } from '../modal';

import { SkyConfirmationDialogService } from './confirmation-dialog.service';
import { SkyConfirmationDialogComponent } from './confirmation-dialog.component';
import { SkyResourcesModule } from '../resources';


export class SkyConfirmationDialogModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyConfirmationDialogComponent
  ],
  imports: [
    CommonModule,
    SkyModalModule,
    SkyResourcesModule
  ],
  exports: [
    SkyConfirmationDialogComponent
  ],
  providers: [
    SkyConfirmationDialogService
  ],
  entryComponents: [
    SkyConfirmationDialogComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
